import { serverData } from "serverData";
import { getSkinByKey } from "themes/skin";

export default getSkinByKey(serverData.skinKey);
